import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

const duration = 250;
const defaultContainerStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const defaultTransitionStyles = {
  exiting: { opacity: 1 },
  entered: { opacity: 1 },
  exited: { opacity: 0, display: 'none' },
};

const FadeInWrapper = ({ children, isVisible, transitionStyle, containerStyle }) => (
  <Transition in={isVisible} timeout={duration} exit={false}>
    {(transitionState) => <div style={{ ...containerStyle, ...transitionStyle[transitionState] }}>{children}</div>}
  </Transition>
);

FadeInWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool.isRequired,
  transitionStyle: PropTypes.object,
  containerStyle: PropTypes.object,
};

FadeInWrapper.defaultProps = {
  transitionStyle: defaultTransitionStyles,
  containerStyle: defaultContainerStyle,
};

export default FadeInWrapper;
